import { ScopeModel as e } from "../../../../features/api/models/scope/scope.model.js";
import u from "./backend/useRestaurantDays.js";
function L() {
  const { data: d, mutateAsync: i, isLoading: s } = u();
  return {
    data: d,
    isLoading: s,
    orderLater: async (r, o, t) => {
      const { availability: n } = await i({
        serviceType: o,
        address: {
          address: (t == null ? void 0 : t.formattedAddress) ?? "",
          latitude: (t == null ? void 0 : t.lat) ?? 0,
          longitude: (t == null ? void 0 : t.long) ?? 0
        },
        scope: new e(
          void 0,
          r.map((a) => a.id)
        )
      });
      return {
        restaurants: r,
        availability: n ?? [],
        service: o
      };
    }
  };
}
export {
  L as default
};
//# sourceMappingURL=useOrderLater.js.map
